import { Button } from 'antd';
import { Buttons, ButtonsGroup } from './styles/button.style';
const isoButton = Buttons(Button);
const ButtonGroup = ButtonsGroup(Button.Group);

export default isoButton;
export { ButtonGroup };
